import React from 'react';
import { Table, Button, Card, Typography, Space, Tag } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';

const { Title, Text } = Typography;

interface Dataset {
  id: string;
  name: string;
  description: string;
  updatedAt: string;
  status: 'active' | 'draft';
}

const mockDatasets: Dataset[] = [
  { id: '1', name: 'Sales Orders', description: 'All sales orders from 2023-2024', updatedAt: '2024-12-20', status: 'active' },
  { id: '2', name: 'Customer Master', description: 'Customer details and demographics', updatedAt: '2024-12-23', status: 'active' },
  { id: '3', name: 'Inventory Logs', description: 'Daily inventory snapshot', updatedAt: '2024-12-24', status: 'draft' },
];

const DatasetListPage: React.FC = () => {
  const navigate = useNavigate();
  const { workspaceId } = useParams();

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text: string) => <Text strong>{text}</Text>,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <Tag color={status === 'active' ? 'green' : 'orange'}>
          {status.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: 'Last Updated',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: Dataset) => (
        <Space size="middle">
          <Button 
            type="text" 
            icon={<EditOutlined />} 
            onClick={() => navigate(`/${workspaceId}/dataset/${record.id}`)}
          >
            Edit
          </Button>
          <Button 
            type="text" 
            danger
            icon={<DeleteOutlined />} 
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <Title level={2} style={{ marginTop: 0 }}>Datasets</Title>
          <Text type="secondary">Manage your data models and definitions.</Text>
        </div>
        <Button 
          type="primary" 
          icon={<PlusOutlined />} 
          onClick={() => navigate(`/${workspaceId}/dataset/new`)}
        >
          Create Dataset
        </Button>
      </div>

      <Card>
        <Table columns={columns} dataSource={mockDatasets} rowKey="id" />
      </Card>
    </div>
  );
};

export default DatasetListPage;
